import { AppDispatch } from 'src/store';
import { createAction } from '@reduxjs/toolkit';

import { IMerchantAccount } from '../accountsPayment/types';

import { fetchMerchantAccountPayoutByIdRequest, updateProvidersMerchantPayoutRequest } from './requestHandlers';

export const loadAccountsStart = createAction('accounts_payout/load/start');
export const loadAccountDetailsSuccess = createAction<IMerchantAccount>('accounts_payout/details/load/success');
export const resetAccountDetails = createAction('accounts_payout/details/reset');

export const loadAccountPayoutDetailsRequest = (id: string) => {
  return async (dispatch: AppDispatch): Promise<boolean> => {
    dispatch(loadAccountsStart());

    const data = await fetchMerchantAccountPayoutByIdRequest(id);

    if (data) {
      dispatch(loadAccountDetailsSuccess(data));
    }

    return true;
  };
};

export const updateProvidersPayoutMerchant = (data: Partial<IMerchantAccount>) => {
  return async (dispatch: AppDispatch): Promise<IMerchantAccount | null> => {
    const res = await updateProvidersMerchantPayoutRequest(data);
    if (res) {
      dispatch(loadAccountDetailsSuccess(res));
    }
    return res;
  };
};
